<!-- <div class="side-menu">
    <div style="text-align: end">
        <app-button [icon]="icon" [style]="'p-button-secondary p-button-text p-button-sm'" (onClickEvent)="toggleMenu()"></app-button>
    </div>
    <app-panel-menu [hidden]="hidden" [Items]="Items"></app-panel-menu>
</div> -->
<p-menubar [model]="Items"></p-menubar>